import { ref, readonly } from 'vue'

// グローバルな状態を保持
const theme = ref('light')

const toggleTheme = () => {
  theme.value = theme.value === 'light' ? 'dark' : 'light'
  applyTheme(theme.value)
  saveThemePreference(theme.value)
}

const applyTheme = (themeName) => {
  try {
    if (!['light', 'dark'].includes(themeName)) {
      throw new Error('Invalid theme name')
    }
    // 既存のテーマクラスを削除
    document.documentElement.classList.remove('theme-light', 'theme-dark')
    // 新しいテーマクラスを追加
    document.documentElement.classList.add(`theme-${themeName}`)
  } catch (error) {
    console.warn('Failed to apply theme, falling back to light mode:', error)
    document.documentElement.classList.remove('theme-light', 'theme-dark')
    document.documentElement.classList.add('theme-light')
    theme.value = 'light'
  }
}

const saveThemePreference = (themeName) => {
  try {
    if (typeof Storage !== 'undefined') {
      localStorage.setItem('hstorage-theme', themeName)
    }
  } catch (error) {
    console.warn('Failed to save theme preference:', error)
  }
}

const loadThemePreference = () => {
  try {
    if (typeof Storage !== 'undefined') {
      const saved = localStorage.getItem('hstorage-theme')
      if (saved && ['light', 'dark'].includes(saved)) {
        return saved
      }
    }
  } catch (error) {
    console.warn('Failed to load theme preference:', error)
  }
  return 'light'
}

const initializeTheme = () => {
  const savedTheme = loadThemePreference()
  theme.value = savedTheme
  applyTheme(savedTheme)
}

const setTheme = (themeName) => {
  if (!['light', 'dark'].includes(themeName)) {
    console.warn('Invalid theme name, falling back to light')
    themeName = 'light'
  }
  theme.value = themeName
  applyTheme(themeName)
  saveThemePreference(themeName)
}

export function useTheme() {
  return {
    theme: readonly(theme),
    toggleTheme,
    applyTheme,
    loadThemePreference,
    initializeTheme,
    setTheme
  }
}